'use client';

import { useRouter } from 'next/navigation';
import { type KeyboardEvent, type ReactNode } from 'react';

interface AboutButtonProps {
  children: ReactNode;
}

export default function AboutButton({ children }: AboutButtonProps): React.JSX.Element {
  const router = useRouter();

  const handleClick = (): void => {
    router.push('/menu/');
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleClick();
    }
  };

  return (
    <button
      className="narrative-content"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {children}
    </button>
  );
}
